import React from 'react'

export const ExternalResourceIcon = React.memo<JSX.IntrinsicElements['svg']>(
  (props) => {
    return (
      <svg
        width="16"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.32 5h5v5h-1V6.707l-4.613 4.612L5 10.612 9.612 6H6.319V5z"
          fill="#D23F0E"
        />
      </svg>
    )
  },
)
